// LET OP: gebruik de jQuery-instantie uit de bundle (net als magnific-popup.js).
// De bundle heeft zijn eigen jQuery (webpack "externals" staat uit in
// webpack/config.base.js), en jquery-match-height registreert $.fn.matchHeight
// ALLEEN op die instantie.
//
// Met `jQuery(document).ready(function ($) {...})` overschaduwde de callback-
// parameter $ de bundle-jQuery met de globale WordPress-jQuery — die geen
// matchHeight kent: "Uncaught TypeError: $(...).matchHeight is not a function".
// carousel.js ontsnapte hieraan doordat die callback géén $-parameter heeft en
// dus op window.$ (= de bundle-jQuery, gezet in style.js) uitkomt.
import $ from 'jquery';
import 'jquery-match-height';

$(document).ready(function () {

    let bumpIt = function () {
        const pixels = ($(window).width() - $('#contain').width()) / 2;

        $('.slide-off-right').css('margin-right', -pixels);
        $('.slide-off-right-animate').css('margin-right', -pixels);
        $('.slide-off-left-animate').css('margin-left', -pixels);
        $('.slide-off-left').css('margin-left', -pixels);
        $('.pagina-item .inner').css('height', $('.pagina-item').width());
        $('.pageslide .inner').css('height', $('.pageslide').width());
        //$('.logo-gallery .logo-item').css('height', $('.logo-gallery .logo-item').width());
    };

    bumpIt();

    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(bumpIt, 250);
    });

    $('ul.links li').click(function () {
        var button = $(this);
        var active = button.data('rel');
        var links = button.parent();
        var content = links.parent().children('.focus');

        links.children('li').removeClass('active');
        button.addClass('active')

        content.children().removeClass('active');
        content.find('#' + active).addClass('active')
    });

    $('.vacatureslide').matchHeight({
        byRow: true,
        property: 'height',
    });

});
